export default __webpack_public_path__ + "static/media/gitt.43d387b7.svg";